module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Buried-Knights-Templar-1.5fe1518.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Buried-Knights-Templar-1.jpg
// module id = XW35
// module chunks = 0